import { render } from "./repair.vue?vue&type=template&id=63f6be98&scoped=true"
import script from "./repair.vue?vue&type=script&lang=js"
export * from "./repair.vue?vue&type=script&lang=js"

import "./repair.vue?vue&type=style&index=0&id=63f6be98&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f6be98"]])

export default __exports__